import { useDispatch, useSelector } from 'react-redux';
import { useRef, useState } from 'react';
import { fileActions } from '../../store/files-slice';
import { signDocuments } from '../../api/studiesAPI';
import { popBlob, setBlob } from '../../store/blob-store';
import { Icon } from '@mui/material';

import './FileSelector.scss';

const FileSelector = ({
	title,
	label,
	documentType,
	multiple
}) => {
	const [itemsExpanded, setItemsExpanded] = useState(false);
	const fileList = useSelector(
		(state) => state.filesManager.files
	).filter((f) => f.documentType === documentType);

	const inputRef = useRef();

	const dispatch = useDispatch();

	const buildFileSlice = (files) => {
		const filePromises = files.map(async (file) => {
			// add a timestamp to every file name
			const uploadFileName = `${Date.now()}_${file.name
				.replace(/[^a-zA-Z0-9\s.]/g, '')
				.replace(/\.(?=.*\.)/g, '')
				.replaceAll(' ', '_')}`;
			// get the signed url to store the files in the s3 bucket
			const urlObjs = await signDocuments([uploadFileName]);

			const resultUrlObjects = urlObjs.data.signedDocs;
			// let the name with the timestamp as the original name to avoid conflicts in the DB
			const resultUrl = resultUrlObjects.filter(
				(e) => e.originalName === uploadFileName
			)[0].url;
			// TODO check for a better place to set blob
			setBlob(uploadFileName, file);
			return {
				name: uploadFileName,
				lastModified: file.lastModified,
				documentType,
				signedPutUrl: resultUrl
			};
		});
		return Promise.all(filePromises);
	};

	const handleFileChange = async (event) => {
		// create an array with the files selected
		const filesArray = Array.from(event.target.files);
		// store the files processed by buildFileSlice into the Slice
		const filesData = await buildFileSlice(filesArray);
		dispatch(fileActions.addFiles(filesData));
	};

	const clickHandler = () => {
		inputRef.current.click();
	};

	const toggleDocsDetails = (event) => {
		event.stopPropagation();
		setItemsExpanded((prev) => !prev);
	};

	const deleteFile = (name) => {
		popBlob(name);
		dispatch(fileActions.removeFile(name));
	};

	return (
		<div
			className='file-selector-container'
			onClick={clickHandler}
		>
			<div className='selector-icon-container'>
				<Icon>folder_open</Icon>
			</div>
			<div className='selector-data-container'>
				<p className='selector-text selector-title'>
					{title}
				</p>
				<div className='selector-text selector-subtitle'>
					{fileList.length === 0 && <span>{label}</span>}
					{fileList.length > 0 && (
						<span
							className='selector-expand-items'
							onClick={toggleDocsDetails}
						>
							Documents uploaded: {fileList.length}
							{!itemsExpanded && (
								<Icon className='expand-control'>
									expand_more
								</Icon>
							)}
							{itemsExpanded && (
								<Icon className='expand-control'>
									expand_less
								</Icon>
							)}
						</span>
					)}
				</div>
				<input
					className='hidden-selector'
					type='file'
					onChange={handleFileChange}
					multiple={multiple}
					ref={inputRef}
				/>
				{fileList.length > 0 && itemsExpanded && (
					<ul className='documents-selected-list'>
						{fileList.map((file) => (
							<li
								key={file.name}
								className='document-selected-item'
							>
								<span className='document-name'>
									{file.name}
								</span>
								<Icon
									className='remove-document'
									onClick={() => deleteFile(file.name)}
								>
									delete
								</Icon>
							</li>
						))}
					</ul>
				)}
			</div>
		</div>
	);
};
export default FileSelector;
